import { format } from 'date-fns'
import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../../../store/reducers/rootReducer'
import { IWorkerItem } from '../../../../../../modules/API/Defaults/models/workers'
import { ICreateSortingData } from '../../../../../../modules/API/Miun/models/fetchData'
import { Miun } from '../../../../../../modules/API/Miun/miun'
import { Defaults } from '../../../../../../modules/API/Defaults/defaults'
import { IVarietyListResponse } from '../../../../../../modules/API/Defaults/models/varietyList'
import { ISortingListItem } from '../../../../../../modules/API/Miun/models/sortingList'
import useDataFetcher from '../../../knisot/hooks/useFetchData'
import selectBrodMigdal from '../../../../../../generic/utils/selectBrodMigdal'

interface UseCreateSortingParams {
    uppendData: (data: ISortingListItem) => void
    closeFunc: () => void
}

const useCreateSorting = ({ uppendData, closeFunc }: UseCreateSortingParams) => {
    const defaults = useSelector((state: RootState) => state.defaults.defaults)
    const defaultProduct: number = selectBrodMigdal(defaults, 7, 'Num_Value')
    const defaultVariety: number = selectBrodMigdal(defaults, 8, 'Num_Value')
    const defaultTransit: number = selectBrodMigdal(defaults, 5, 'Num_Value')
    const isRequireVariety: number = selectBrodMigdal(defaults, 302, 'Logical_Value')

    const user = useSelector((state: RootState) => state.mainReducer.user)
    const workerList: IWorkerItem[] = useSelector(
        (state: RootState) => state.defaults.workerList,
    )

    const [sortingCreateDate, setSortingCreateDate] = useState<Date>(new Date())
    const [grower, setGrower] = useState<number>(0)
    const [product, setProduct] = useState<number>(defaultProduct || 0)
    const [variety, setVariety] = useState<number>(defaultVariety || 0)
    const [remarks, setRemarks] = useState<string>('')
    const [sortingReference, setSortingReference] = useState<number>(0)
    const [warhouse, setWarhouse] = useState<number>(
        defaultTransit || (user ? Number(user.tranzit) : 0),
    )

    const { data: varietyList, isLoading: varietyListIsLoading } =
        useDataFetcher<IVarietyListResponse>(
            Defaults.getVarietyByProductID,
            (product || 0).toString(),
        )

    const worker = useMemo(() => {
        if (!workerList || !user?.code_internal) return ''
        return (
            workerList.find((item) => item.WorkerId === +user.code_internal)?.WorkerName ||
            'Office'
        )
    }, [user, workerList])

    const isAllowToCreate = !!(
        product &&
        grower &&
        warhouse &&
        sortingReference &&
        (isRequireVariety ? !!variety : true)
    )

    const postCreateSorting = async () => {
        if (!isAllowToCreate) return
        const regTime = format(new Date(), 'HHmmss')
        const data: ICreateSortingData = {
            Date_Sorting: format(sortingCreateDate, 'yyyyMMdd'),
            GrowerID: grower,
            ProductID: product,
            Remarks: remarks,
            Sorting_Reference: sortingReference,
            Time_Sorting: regTime,
            VarietyID: variety,
            WarehouseID: warhouse,
            WorkerName: worker,
        }
        try {
            const res: ISortingListItem = await Miun.createSorting(data)
            uppendData(res)
            closeFunc()
        } catch {
            /* noop */
        }
    }

    return {
        sortingCreateDate,
        setSortingCreateDate,
        grower,
        setGrower,
        product,
        setProduct,
        variety,
        setVariety,
        remarks,
        setRemarks,
        sortingReference,
        setSortingReference,
        warhouse,
        setWarhouse,
        varietyList: varietyList?.variety || [],
        varietyListIsLoading,
        defaultProduct,
        defaultVariety,
        defaultTransit,
        isRequireVariety,
        user,
        isAllowToCreate,
        postCreateSorting,
    }
}

export default useCreateSorting
